import { render, staticRenderFns } from "./ListOrbitOwnersView.vue?vue&type=template&id=353bc0c9&scoped=true"
import script from "./ListOrbitOwnersView.vue?vue&type=script&lang=ts"
export * from "./ListOrbitOwnersView.vue?vue&type=script&lang=ts"
import style0 from "./ListOrbitOwnersView.vue?vue&type=style&index=0&id=353bc0c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353bc0c9",
  null
  
)

export default component.exports